/* global Image */
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Lazyload = function( el ) {
  var iterate = function() {
    if ( $( this ).hasClass( "js-kill-load" ) ) {
      return;
    }

    var src = $( this ).attr( "data-src" ) || "", img = new Image(), el = this;

    img.onload = function() {
      if ( el.tagName === "DIV" ||
        el.tagName === "A" ||
        el.tagName === "FIGURE" ||
        el.tagName === "LI" ||
        el.tagName === "SECTION"
      ) {
        el.style.backgroundImage = "url(" + src + ")";
      } else if ( el.tagName === "IMG" ) {
        if ( !!el.parent ) {
          el.parent.replaceChild( img, el );
         } else {
          el.src = src;
        }
      }

      setTimeout(function() {
        $( el ).addClass( "visible" );
      }, 300 );

    };
    img.src = "" + src;
  };

  if ( !el ) {
    $( "[data-src]" ).each( iterate );
  } else {
    iterate.call( el );
  }

  $( "[data-bg-lazy]" ).each(function() {
    var bgEl = this;
    var bgStyle = $( bgEl ).css( "background-image" );
    var bgSrc = "";

    // Some browsers wrap URL value in quotes, some don't.
    if ( bgStyle.indexOf( "url(h" ) === 0 ) {
      bgSrc = bgStyle.substr( 4, bgStyle.length - 5 );
    } else {
      bgSrc = bgStyle.substr( 5, bgStyle.length - 7 );
    }

    var bgImage = new Image();

    bgImage.src = bgSrc;

    $( bgImage ).one( "load", function() {
      setTimeout(function() {
        $( bgEl ).addClass( "visible" );
      }, 300 );
    });

    if ( bgImage.complete ) {
      $( bgImage ).trigger( "load" );
    }
  });
};

$.fn.lazyLoad = function( args ) {
  var _ = this;
  _.each(function() {
    new Lazyload( this, args );
  });
};

module.exports = Lazyload;
